module.exports = __webpack_public_path__ + "img/Steor-Icons-19.b6244835.svg";